/**
 * KubernetesStorageClassAccessPolicies Model
 */
const _KubernetesStorageClassAccessPolicies = Object.freeze([
  {
    Name: 'RWO',
    Description: 'Чтение и запись только из одного пода (RWO)',
    selected: true,
  },
  {
    Name: 'RWX',
    Description: 'Одновременное чтение и запись из нескольких подов (RWX)',
    selected: false,
  },
]);

export function KubernetesStorageClassAccessPolicies() {
  return JSON.parse(JSON.stringify(_KubernetesStorageClassAccessPolicies));
}

/**
 * KubernetesStorageClass Model
 */
const _KubernetesStorageClass = Object.freeze({
  Name: '',
  AccessModes: [],
  Provisioner: '',
  AllowVolumeExpansion: false,
});

export class KubernetesStorageClass {
  constructor() {
    Object.assign(this, JSON.parse(JSON.stringify(_KubernetesStorageClass)));
  }
}
